<script context="module" lang="ts">
  import type { Component } from '$lib';

  export type ListItem = {
    icon: Component;
    displayName: string;
    orderBy: string;
    sortBy: 'asc' | 'desc';
  };
</script>

<script lang="ts">
  import DropdownListItem from '$lib/components/common/dropdownButton/DropdownListItem.svelte';
  import DropdownButton from '$lib/components/common/dropdownButton/DropdownButton.svelte';

  export { classname as class };

  export let onItemSelect = (_orderBy: string, _sortBy: 'asc' | 'desc') => {};
  export let onButtonClick: () => void = () => {};
  let toggleShowList: (toggle: boolean) => void;

  export let orderBy: string | undefined;
  export let sortBy: 'asc' | 'desc';
  export let items: ListItem[] = [];

  $: selectedName = items.find((a) => a.orderBy === orderBy && a.sortBy === sortBy)?.displayName ?? '';
  $: label = `Sort: ${selectedName}`;

  const handleItemClick = (item: ListItem) => {
    orderBy = item.orderBy;
    sortBy = item.sortBy;
    selectedName = item.displayName;
    onItemSelect(orderBy, sortBy);
    toggleShowList(false);
  };
</script>

<DropdownButton
  {label}
  icon="sort"
  iconPosition="right"
  iconSize="12px"
  buttonClass="min-w-[100px]"
  onClick={() => {
    onButtonClick();
  }}
  bind:toggleShowList
>
  <ol class="list">
    {#each items as item}
      <li>
        <DropdownListItem class="h-[36px]" onClick={() => handleItemClick(item)}>
          <svelte:component this={item.icon} size="16px" weight="bold" />
          <span class="text-md ml-2"> {item.displayName}</span>
        </DropdownListItem>
      </li>
    {/each}
  </ol>
</DropdownButton>

<style lang="postcss">
</style>
